import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
} from '@angular/core';

import { IWinSkin } from '@features/cases/interfaces/cases.interface';
import { ActivatedRoute } from '@angular/router';
import { RewardsService } from '../services/rewards.service';
import { ToastrService } from 'ngx-toastr';
import { SvgIconComponent } from 'angular-svg-icon';
import {
  CasesUnboxingComponent,
  CaseUnboxingSettings,
} from '@features/cases/cases-unboxing/cases-unboxing.component';

@Component({
  selector: 'app-rewards-daily-unboxing',
  imports: [CasesUnboxingComponent, SvgIconComponent],
  templateUrl: './rewards-daily-unboxing.component.html',
  styleUrl: './rewards-daily-unboxing.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  host: {
    class: 'container-xl',
  },
})
export class RewardsDailyUnboxingComponent {
  private route = inject(ActivatedRoute);
  private rewardsService = inject(RewardsService);
  private toastrService = inject(ToastrService);

  currentCase = computed(
    () =>
      this.rewardsService
        .dailyCasesWithRequirements()
        .find(
          (caseItem) =>
            caseItem.link === this.route.snapshot.paramMap.get('link')
        ) ?? null
  );

  unboxingConfig = computed<CaseUnboxingSettings>(() => {
    return {
      spinner: {
        amount: false,
      },
      caseItem: {
        detailsType: 'category' as const,
        locked:
          !this.currentCase()?._is_available ||
          this.currentCase()?._already_opened ||
          false,
      },
      openButton: {
        disabled:
          !this.currentCase()?._is_available ||
          this.currentCase()?._already_opened ||
          false,
        text: this.currentCase()?._is_available
          ? this.currentCase()?._already_opened
            ? 'Already Opened'
            : `Open ${this.currentCase()?.name}`
          : 'Unavailable',
      },
      openFn: () => this.handleOpenCase(),
      balanceType: 'skins',
      navigation: {
        backText: 'Back to Rewards',
        backLink: ['/rewards'],
      },
      openSettings: {
        skipFirstBalanceUpdate: true,
      },
    };
  });

  private async handleOpenCase(): Promise<IWinSkin[]> {
    const currentCase = this.currentCase();

    if (currentCase === null) {
      this.toastrService.error('Case not found');
      return [];
    }

    const result = await this.rewardsService.openDailyCase(currentCase.link);
    this.rewardsService.dailyCasesWithRequirements.update((prev) => {
      return prev.map((item) => {
        if (item.link === currentCase.link) {
          return { ...item, _already_opened: true };
        }
        return item;
      });
    });

    return result;
  }
}
